module.exports = __webpack_public_path__ + "img/novelphonetwo.afaceb93.png";